// extracted by mini-css-extract-plugin
export default {"input":"ModalAddPost_input__8Su2S"};